import { useSyncExternalStore } from 'react';
import { APP_ROOT_ELEMENT_ID } from './constants-generated';
// All personal menu outlet selectors. Personal menu will render its content to these elements with React createPortal
const outletSelectors = [
// This is old outlet that is rendered by the Online
`#${APP_ROOT_ELEMENT_ID}`,
// This is new version of outlet selector used by top-area
'*[data-personal-menu-outlet]'];
const getPersonalMenuOutlets = () => [...document.querySelectorAll(outletSelectors.join(', '))];
let listeners = [];
// Find all default outlets currently on the page
let outlets = getPersonalMenuOutlets();
const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      outlets = getPersonalMenuOutlets();
      // Emit change event to all listeners
      for (const listener of listeners) {
        listener();
      }
    }
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});
const store = {
  subscribe(listener) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },
  getSnapshot() {
    return outlets;
  }
};
export const useOutlets = () => useSyncExternalStore(store.subscribe, store.getSnapshot);